// common constants

// filetype constants
export const GERBER = 'gerber'
export const DRILL = 'drill'

// units constants
export const MM = 'mm'
export const IN = 'in'

// format constants
export const LEADING = 'leading'
export const TRAILING = 'trailing'
export const ABSOLUTE = 'absolute'
export const INCREMENTAL = 'incremental'

// tool constants
export const CIRCLE = 'circle'
export const RECTANGLE = 'rectangle'
export const OBROUND = 'obround'
export const POLYGON = 'polygon'
export const MACRO_SHAPE = 'macroShape'

// macro primitive codes
export const MACRO_CIRCLE = '1'
export const MACRO_VECTOR_LINE = '20'
export const MACRO_CENTER_LINE = '21'
export const MACRO_OUTLINE = '4'
export const MACRO_POLYGON = '5'
export const MACRO_MOIRE = '6'
export const MACRO_THERMAL = '7'

// drawing constants
export const SHAPE = 'shape'
export const MOVE = 'move'
export const SEGMENT = 'segment'
export const SLOT = 'slot'

// interpolation / routing constants
export const LINE = 'line'
export const CW_ARC = 'cwArc'
export const CCW_ARC = 'ccwArc'

// quadrant mode
export const SINGLE = 'single'
export const MULTI = 'multi'

// load polarity
export const DARK = 'dark'
export const CLEAR = 'clear'
